import React, { useState } from "react";
import { Card, CardImg, CardBody, CardText, Badge } from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import bedImg from "assets/images/bedroom.png";
import bathImg from "assets/images/bath.png";
import distanceImg from "assets/images/distance.png";
import AuthCard from "./AuthCard";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const CompoundCard = ({ compound, history, location }) => {
	const { t } = useTranslation();
	const [modal, setModal] = useState(false);
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);

	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			history.push(`/compound-details/${compound.id}`);
		} else {
			dispatch(
				authenticate({ navigateTo: `/compound-details/${compound.id}` })
			);
			history.push(`/login`, {
				navigateTo: `/compound-details/${compound.id}`,
			});
		}
	};

	return (
		<React.Fragment>
			<div className="websitPages" onClick={() => checkAuth()}>
				<div className="position-relative projectName px-md-2">
					{/* <i className="fa cursor-pointer bgheartResale fa-heart" /> */}
					<Card className="comCard">
						{compound?.images?.length > 0 ? (
							compound?.images?.map((img, index) => {
								if (index === 0) {
									return <CardImg key={index} src={img.path}></CardImg>;
								}
							})
						) : (
							<CardImg src={compoundImg}></CardImg>
						)}
						{/* {compound ?.developer ?.media ?.id ?
                            <img
                                src={compound.developer.media.path}
                                className='imgAbsolute'
                            />
                            :
                            <img
                                src={developerdImg}
                                className='imgAbsolute'
                            />
                            } */}
						<CardBody>
							<CardText
								tag="h4"
								style={{ fontWeight: 800, height: "80px" }}
								className="text-card gotham-font mb-0 font-size-32">
								{compound?.name[`${AuthData.lang}`]
									? compound?.name[`${AuthData.lang}`]
									: compound?.name?.en}
							</CardText>

							<CardText
								tag="p"
								// style={{height: '21px'}}
								className="text-card h-24 fw-medium gotham-font font-size-16">
								{compound?.area?.name[AuthData?.lang]}
							</CardText>
							{/* <div className="d-flex justify-content-between roomsBeds border-bottom">
                                <p className="d-flex gap-2"><img src={bedImg} width="16px" height="16px" alt="" /><span className="font-size-12">3 Rooms</span></p>
                                <p className="d-flex gap-2"><img src={bathImg} width="16px" height="16px" alt="" /><span className="font-size-12">2 Bathrooms</span></p>
                                <p className="d-flex gap-2"><img src={distanceImg} width="16px" height="16px" alt="" /><span className="font-size-12">250  m <sup>2</sup></span></p>
                            </div> */}
							<CardText
								tag="p"
								className="font-size-14 text-card gotham-font h-88 com-description">
								{compound?.description[AuthData?.lang]
									? compound?.description[AuthData?.lang]
									: compound?.description?.en}
							</CardText>
							<hr />
							<CardText tag="h6" className="font-size-14 text-card gotham-font">
								{compound?.installmen &&
									t("up to installment", {
										num: Number(compound?.installment),
									})}
							</CardText>
							{/* {compound ?.unit_types ?.length > 0 ? compound ?.unit_types ?.map((unit, index) => {
                                return (
                                    <Badge
                                        key={index}
                                        className="bgBadge font-size-12"
                                    >
                                        {unit ?.name[`${AuthData.lang}`] ? unit ?.name[`${AuthData.lang}`] :unit ?.name ?.en} 
                                    </Badge>
                                )
                            }) : null} */}
							<CardText tag="h5" className="font-size-14 text-card">
								{t("Installements up to")} {compound?.installment} {t("years")}
							</CardText>
							<CardText tag="h2" className="pb-2 d-flex text-card">
								<span className="font-size-14 pe-3">{t("starting from")} </span>
								<span className="font-size-24 fw-bold">
									{" "}
									{toCurrency(compound?.starting_from)}{" "}
									{/* {currency?.currency_code}{" "} */}
								</span>
							</CardText>
							<button className="btn btnMoreInfo mt-4">
								{t("More Information")}
							</button>
						</CardBody>
					</Card>
				</div>
			</div>
			{/* <AuthCard modal={modal} setModal={setModal} history={history} location={location} /> */}
		</React.Fragment>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default CompoundCard;
